import { indexItems } from '@/mocks/homeData';

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 scroll-mt-16 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 text-xs font-medium text-accent-700 bg-accent-100 rounded-full mb-3">快速入口</span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">漫画分类</h2>
          <p className="text-sm text-foreground-500 mt-2 max-w-lg mx-auto">九大漫画题材分类，快速找到你喜欢的类型</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {indexItems.map((item) => (
            <a key={item.id} href="#cards" className="group flex items-center gap-4 p-4 rounded-lg bg-background-50 border border-background-200/70 hover:border-accent-300 transition-all cursor-pointer no-underline">
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 group-hover:bg-accent-500 group-hover:text-background-50 transition-colors flex-shrink-0">
                <i className={`${item.icon} text-xl`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center justify-between mb-0.5">
                  <h3 className="font-heading font-bold text-sm text-foreground-900 group-hover:text-accent-600 transition-colors">{item.label}</h3>
                  <span className="text-xs text-foreground-400 whitespace-nowrap">{item.count}</span>
                </div>
                <p className="text-xs text-foreground-500">{item.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}